export const EXPENSE_STORAGE_ID = 'expenses';
